export const modelingProjects = [
  'habarovsk_akadem',
  'habarovsk_tpim',
  'gbu_bdd_kazan',
  'rostov_on_don',
  'spb_politekh',
  'vladikavkaz',
  'rostov_tmp',
  'cheboksary',
  'vladimir',
  'tashkent',
  'academic',
  'loadtest',
  'spb_gasu',
  'avtodor',
  'labgrad',
  'instroj',
  'cpt_spb',
  'mg_ekat',
  'kubgtu',
  'invest',
  'irano',
  'urgups',
  'sibadi',
  'uunit',
  'niipi',
  'eputs',
  'tomsk',
  'niiat',
  'vshe',
  'demo',
  'urfu',
  'lgtu',
  'istu',
  'guap',
  'madi',
  'omsk',
  'trti',
  'sfu',
  'guu',
  'kdh',
  'ctt',
  'vtm',
  'rut',
  'tiu'
]

export const gisProjects = [
  'habarovsk_akadem',
  'habarovsk_tpim',
  'habarovsk_gis',
  'rostov_on_don',
  'transport_int',
  'gbu_bdd_kazan',
  'spb_politekh',
  'vladikavkaz',
  'rostov_tmp',
  'cheboksary',
  'rut_miit',
  'tashkent',
  'academic',
  'loadtest',
  'vladimir',
  'brusnika',
  'spb_gasu',
  'spetsdor',
  'minimal',
  'labgrad',
  'instroj',
  'cpt_spb',
  'mg_ekat',
  'avtodor',
  'kubgtu',
  'invest',
  'ryazan',
  'surgut',
  'urgups',
  'sibadi',
  'irano',
  'tagil',
  'eputs',
  'niiat',
  'tomsk',
  'uunit',
  'niipi',
  'vshe',
  'istu',
  'madi',
  'lgtu',
  'demo',
  'urfu',
  'omsk',
  'guap',
  'trti',
  'sfu',
  'kdh',
  'guu',
  'ctt',
  'tiu',
  'vtm',
  'mgu',
  'rut',
  'mmk'
]
